<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">Adicionar Usuário</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-row>
          <v-col md="6">
            <v-text-field
              label="Nome"
              v-model="fields.name.value"
              :rules="[...fields.name.rules, ...fields.name.apiErrors]"
              type="text"
              @input="fields.name.apiErrors = []"
              outlined dense
            ></v-text-field>
            <v-text-field
              label="E-mail"
              v-model="fields.email.value"
              :rules="[...fields.email.rules, ...fields.email.apiErrors]"
              type="email"
              @input="fields.email.apiErrors = []"
              outlined dense
            ></v-text-field>
            <v-text-field
              label="Senha"
              v-model="fields.password.value"
              :rules="[...fields.password.rules, ...fields.password.apiErrors]"
              type="password"
              @input="fields.password.apiErrors = []"
              outlined dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn color="success" :disabled="sending" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'userForm',
  data: () => ({
    fields: {
      name: {
        value: '',
        rules: [
          v => !!v || 'O nome é obrigatório'
        ],
        apiErrors: []
      },
      email: {
        value: '',
        rules: [
          v => !!v || 'O e-mail é obrigatório',
          v => /.+@.+\..+/.test(v) || 'Precisa ser um e-mail válido'
        ],
        apiErrors: []
      },
      password: {
        value: '',
        rules: [
          v => !!v || 'A senha é obrigatória',
          v => v.length >= 8 || 'A senha deve conter no mínimo 8 caracteres'
        ],
        apiErrors: []
      }
    },
    sending: false,
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    send () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        axios('users', {
          method: (vue.id) ? 'put' : 'post',
          data: vue.apiData
        })
          .then(response => {
            if (response) {
              vue.sending = false
              vue.SET_SNACKBAR({ text: (vue.id) ? 'Usuário atualizado' : 'Usuário adicionado' })
              vue.$router.push({ name: 'users' })
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 422) {
              if (error.response.data) vue.generateApiErrors(error.response.data)
              vue.errorMessage = 'Verifique os campos com erro'
            } else {
              vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
            }
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  }
}
</script>
